import http from './conn';

class TimeoutService {
  async get() {
    return await http.get('/timeout');
  }
}

export default new TimeoutService();
